import { selectProfile, selectRequestingChangePlan } from '../../../../../store/workspace/selectors';
import { requestChangePlanThunk } from '../../../../../store/workspace/thunks';
import { setContactSalesModal } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import TextArea from '../../../../../components/TextArea';
import { LayerIcon } from '../../../../../assets/icons';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Input';
import { useState } from 'react';

/** Support form used whenever a plan cannot be bought self-serve. */
export default function ContactSales() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const [message, setMessage] = useState('');
    const [subject, setSubject] = useState('');
    const isLoading = useSelector(selectRequestingChangePlan);

    const closeModal = () => dispatch(setContactSalesModal(false));

    const confirmFunc = () => {
        dispatch(requestChangePlanThunk({
            subject,
            message,
            action: 'sales',
            email: profile?.email,
            company: profile?.companyName,
            name: `${profile?.firstName} ${profile?.lastName}`,
        }));
    };

    return (
        <Modal
            size='md'
            actions='both'
            icon={<LayerIcon />}
            title='Contact sales'
            closeFunc={closeModal}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Primary',
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'Confirm',
                type: 'Primary',
                loading: isLoading,
                onClick: confirmFunc,
                disabled: !message || !subject,
            }}
        >
            <span className={styles.description}>
                We’re here to help! Reach out to us with any questions or feedback.
            </span>
            <Input value={subject} onChange={setSubject} type='text' label='Subject' />
            <TextArea value={message} onChange={setMessage} label='Message' />
        </Modal>
    );
};
